import Vue from 'vue';
import axios from 'axios';
import { asyncForEach } from '@/utils';

export default {
  namespaced: true,
  state: {
    selectedDockNumber: null,
    docks: [],
    dock: null,
    loads: [],
    palletsLogs: [],
    palletsStats: [],
    load: null,
    pending: false,
    socket: {
      isConnected: false,
      message: '',
      reconnectError: false
    }
  },
  mutations: {
    setSelectedDockNumber(state, num) {
      state.selectedDockNumber = num;
    },
    setDocks(state, docks) {
      state.docks = docks;
    },
    setDock(state, dock) {
      state.dock = dock;
    },
    setLoads(state, loads) {
      state.loads = loads;
    },
    setPalletsLogs(state, palletsLogs) {
      state.palletsLogs = palletsLogs;
    },
    setPalletsStats(state, palletsStats) {
      state.palletsStats = palletsStats;
    },
    setLoad(state, load) {
      state.load = load;
    },
    replace(state, { o, n }) {
      const i = _.findIndex(state.docks, { number: o.number });
      if (i !== -1) {
        Vue.set(state.docks, i, n);
        if (state.dock.number === n.number) state.dock = n;
      }
    },
    setPending(state, pending) {
      state.pending = pending;
    },
    clearState(state) {
      state.selectedDockNumber = null;
      state.docks = [];
      state.dock = null;
      state.loads = [];
      state.load = null;
      state.palletsLogs = [];
      state.pending = false;
    }
  },
  actions: {
    async fetchDocks({ state, commit }) {
      try {
        state.pending = true;
        // const data = require('./docks.json');
        // await wait(1000);
        // commit('setDocks', data.docks);
        const res = await axios.get('/docks');
        if (res && res.data) commit('setDocks', res.data.docks);
      } finally {
        state.pending = false;
      }
    },
    async fetchDock({ commit }, num) {
      const res = await axios.get('/docks/' + num);
      if (res && res.data) commit('setDock', res.data.dock);
    },
    async fetchPalletsLogs({ state, commit }) {
      try {
        state.pending = true;
        const res = await axios.get('/pallets-logs');
        if (res && res.data) commit('setPalletsLogs', res.data.palletsLogs);
      } finally {
        state.pending = false;
      }
    },
    async fetchPalletsStats({ state, commit }) {
      try {
        state.pending = true;
        const res = await axios.get('/pallets-stats');
        if (res && res.data) commit('setPalletsStats', res.data.palletsStats);
      } finally {
        state.pending = false;
      }
    },
    async loadPallet({ state }, payload) {
      await axios.post('/load', {
        ...payload,
        initials: state.initials
      });
    },
    async loadallPallets({ state }, { palletBreakdowns, payload }) {
      await asyncForEach(palletBreakdowns, async p => {
        await axios.post('/load', {
          ...payload,
          pallet_num: p.pallet_num,
          initials: state.initials
        });
        p.pallet_loaded = 'Not Loaded';
      });
    },
    async unloadPallet(_, payload) {
      await axios.post('/unload', payload);
    }
  }
};
